/**
 * Zonas horarias que se ofrecen al elegir horas de envío.
 *
 * 📌 Es una lista corta a propósito: son las que la operación usa. El backend acepta **cualquier** nombre IANA válido,
 * así que un caso raro se resuelve por API sin tocar esto — y una lista de 400 zonas en un desplegable no ayuda a nadie
 * a encontrar Monterrey.
 *
 * 🔑 Vive aquí desde el 09-oct-2026 porque la usan dos pantallas: los envíos programados de un embarque y las horas de
 * aviso de cada usuario en su perfil. Con una copia en cada una, la siguiente zona se agregaría a una sola.
 */
export const TIME_ZONES = [
  { value: 'America/Monterrey', label: 'Monterrey (CST/CDT)' },
  { value: 'America/Mexico_City', label: 'Mexico City' },
  { value: 'America/Tijuana', label: 'Tijuana' },
  { value: 'America/Chicago', label: 'Chicago' },
  { value: 'America/Los_Angeles', label: 'Los Angeles' },
  { value: 'America/New_York', label: 'New York' },
  { value: 'UTC', label: 'UTC' },
];

export const DEFAULT_TIME_ZONE = 'America/Monterrey';

/**
 * Las zonas a ofrecer, **incluyendo la guardada** aunque no esté en la lista corta.
 *
 * ⚠️ Sin esto, alguien con una zona puesta por API vería el selector vacío y, al guardar otra cosa, la perdería sin
 * darse cuenta.
 */
export const timeZoneOptions = (current?: string | null) =>
  current && !TIME_ZONES.some((z) => z.value === current)
    ? [...TIME_ZONES, { value: current, label: current }]
    : TIME_ZONES;
